import type { ApiError } from "@/client/core/ApiError"
import { OpenAPI } from "@/client/core/OpenAPI"
import { useMutation } from "@tanstack/react-query"

// TODO: These types will be auto-generated after running ./scripts/generate-client.sh
interface SuggestTopicsRequest {
  question_id?: string | null
  question_text: string
  options: string[]
  subject_ids?: string[] | null
}

interface SuggestTopicsResponse {
  suggested_topics: string[]
  provider: string
  model: string
  estimated_cost?: number | null
}

interface SuggestTopicsParams {
  questionText: string
  options: string[]
  questionId?: string
  subjectIds?: string[]
}

export function useSuggestTopics() {
  return useMutation<SuggestTopicsResponse, ApiError, SuggestTopicsParams>({
    mutationFn: async (params) => {
      const apiBaseUrl = (
        OpenAPI.BASE ||
        import.meta.env.VITE_API_URL ||
        ""
      ).replace(/\/$/, "")

      if (!apiBaseUrl) {
        throw new Error(
          "API base URL is not configured. Set VITE_API_URL to your backend origin.",
        )
      }

      const request: SuggestTopicsRequest = {
        question_text: params.questionText,
        options: params.options,
        question_id: params.questionId || null,
        subject_ids: params.subjectIds || null,
      }

      const response = await fetch(`${apiBaseUrl}/api/v1/ai/suggest-topics`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
        body: JSON.stringify(request),
      })

      if (!response.ok) {
        const error = await response.json()
        throw new Error(error.detail || "Failed to suggest topics")
      }

      return response.json()
    },
  })
}
